<template>
    <div id="">
        <loader v-if="isLoading"/>
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs"/>
                    <!-- Botão de Salvar -->
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button v-if="!integracao" 
                    class="save-btn" 
                    type="button" 
                    @click="save" 
                    :disabled="isSaving">
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>
        <div class="page page-container">
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="pacote.idpacoteerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!pacote.idpacoteerp"
                                :disabled="integracao"
                            />
                        </div>
                        <div class="column is-8">
                            <v-input
                                :id="generateId(2)"
                                ref="descricaoInput"
                                v-model="pacote.descricao"
                                placeholder="descricao-pacote-kit-placeholder"
                                :maxlength="50"
                                :title="'descricao'"
                                :required="true"
                                :disabled="(isEdit && isImutavel) || integracao"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!pacote.descricao"
                                uppercase
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select 
                                :id="generateId(3)"
                                ref="situacaoSelect" 
                                :options="situacoes" 
                                :disabled="!isEdit || (isEdit && isImutavel) || integracao"
                                :value="pacote.situacao"
                                title="situacao"
                                tooltipLabel="info-situacao-generica"
                                mlLabels
                            />
                        </div>
                        <div class="column is-6">
                            <vs-select
                                :id="generateId(4)"
                                ref="tabelaPrecoSelect"
                                :title="'tabela-preco'"
                                :options="tabprecos"
                                v-model="pacote.tabpreco"
                                :search="loadTabPreco"
                                :onChange="updateTabPreco"
                                :disabled="(isEdit && isImutavel) || integracao"
                                :getOptionLabel="getLabel"
                                :placeholder="'selecione'"
                                :msg="'msg-campo-obrigatorio'"
                                :required="true"
                                tooltipLabel="info-tabela-preco-pacote-kit"
                            />
                        </div>
                        <div class="column is-6">
                            <vs-select
                                :id="generateId(5)"
                                ref="empresaSelect"
                                :title="'empresa'"
                                :options="empresas"
                                v-model="pacote.empresa"
                                :search="loadEmpresa"
                                :disabled="(isEdit && isImutavel) || integracao"
                                :onChange="updateEmpresa"
                                :getOptionLabel="getLabel"
                                :placeholder="'selecione'"
                                :msg="'msg-campo-obrigatorio'"
                                :required="true"
                                tooltipLabel="info-empresa-pacote-kit"
                            />
                        </div>
                        <div class="column is-6">
                            <vs-select
                                :id="generateId(6)"
                                ref="categoriaSelect"
                                :title="'categoria'"
                                :options="categorias"
                                v-model="pacote.categoria"
                                :disabled="(isEdit && isImutavel) || integracao"
                                :search="loadCategoria"
                                :onChange="updateCategoria"
                                :getOptionLabel="getLabel"
                                :placeholder="'selecione'"
                                tooltipLabel="info-categoria-pacote-kit"
                            />
                        </div>
                        <div class="column is-6">
                            <v-money
                                :id="generateId(7)"
                                ref="qtdeInput"
                                title="qtde-disponivel"
                                placeholder="placeholder-preencha"
                                :value="pacote.qtdedisponivel"
                                @input="updateQtdeDisponivel"
                                :disabled="(isEdit && isImutavel) || integracao"
                                :invalid="isNull(pacote.qtdedisponivel)"
                                :max="9999999"
                                tooltipLabel="info-quantidade-disponivel-pacote-kit"
                            />
                        </div>
                        <div class="column is-6">
                            <verified-date-picker
                                :id="generateId(8)"
                                ref="dataValidadeSelect"
                                placeholder="selecione-uma-data"
                                v-model="pacote.datavalidade"
                                :required="true"
                                :subtractDateYears="0"
                                :addDateYears="8"
                                :yearsRange="[-8,10]"
                                title="data-validade"
                                :inForm="true"
                                :disabled="(isEdit && isImutavel) || integracao"
                                :invalid="!pacote.datavalidade"
                                tooltipLabel="info-data-validade-pacote-kit"
                            />
                        </div>
                        <div class="column is-6">
                            <vss-select
                                :id="generateId(9)"
                                title="imutavel"
                                ref="situacaoSelect" 
                                :options="imutaveis" 
                                :disabled="(isEdit && isImutavel) || integracao"
                                v-model="pacote.imutavel"
                                required
                                mlLabels
                                tooltipLabel="info-imutavel-pacote-kit"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import FilterBar from "@/components/shared/Filter";
import CategoriaService from "@/services/CategoriaService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import TabPrecoService from "@/services/vendas/tabpreco/TabPrecoService";
import PacoteKitService from "@/services/vendas/produto/PacoteKitService";
import PacoteKitValidation from "@/services/validations/PacoteKitValidation";
import Message from "@/models/Message";

export default {
    components: {
        FilterBar,
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes("PACOTE"),
            isLoading: false,
            pacote:{
                descricao: '',
                idpacoteerp: null,
                situacao: { label: "ativo", id: 1, traduzir: true },
                datavalidade: new Date(this.$moment().add(1, "days")),
                imutavel: { label: "sim", id: 1, traduzir: true },
                qtdedisponivel: 0,
                tabpreco: null,
                empresa: null,
                categoria: null,
            },
            situacoes: [{ label: "inativo", id: 0, traduzir: true }, { label: "ativo", id: 1, traduzir: true }],
            imutaveis: [{ label: "nao", id: 0, traduzir: true }, { label: "sim", id: 1, traduzir: true }],
            categorias: [],
            empresas: [],
            isImutavel: false,
            tabprecos: [],
            msgs: [],
            isSaving: false,
            permissao: null,
            isEdit: false,
            isChanged: false,
            validation: null,
            service: new PacoteKitService(this.$http, this.$router),
            serviceCategoria: new CategoriaService(this.$http, this.$router),
            serviceEmpresa: new EmpresaService(this.$http, this.$router),
            serviceTabPreco: new TabPrecoService(this.$http, this.$router),
        };
    },
    watch:{
        pacote:{
            deep: true,
            handler: function () {
                    this.isChanged = true;
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'ven-pacote-kit');

        !this.permissao.read && this.$router.push({
            name: 'acesso-nao-permitido',
            params: { tela: 'pacote-kit' },
        });

        if (this.$route.params.id && this.$route.params.name != 'ven-pacote-kit-new') {
            this.isEdit = true
        }
        this.validation = new PacoteKitValidation(this.msgs)
        this.carregarDados();
    },
    methods: {
        generateId(numberId){
            return this.$route.name+'-'+numberId;
        },
        carregarDados () {
            this.isLoading = true;
            this.loadCategoria()
            this.loadEmpresa()
            this.loadTabPreco()

            if(this.isEdit){
                this.loadPacote()
            } else {
                this.pacote.empresa = this.empresaVazia()
                this.pacote.tabpreco = this.tabPrecoVazia();
                this.pacote.situacao = this.situacoes[1];
                this.pacote.imutavel = this.imutaveis[1];
            }
            this.isChanged = false;
            this.isLoading = false;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        loadPacote(){
            this.service
                .find(this.$route.params.id)
                .then(pacote => {
                    this.mapPacote(pacote.content)
                    this.isChanged = false;
                })
        },
        loadCategoria(value = ".*") {
            this.serviceCategoria
                .findAllCombo(1, value ? value : "")
                .then(this.mapItemsCategoria)
                .then(allCategoria => {
                    this.categorias = allCategoria ? allCategoria : [];
                    this.isChanged = false;
                }, 350);
        },
        loadEmpresa(value = ".*") {
            this.serviceEmpresa
                .findAllCombo(value ? value : "")
                .then(this.mapItemsEmpresa)
                .then(allEmpresa => {
                    this.empresas = allEmpresa ? allEmpresa : [];
                    this.empresas.unshift(this.empresaVazia())
                    this.isChanged = false;
                }, 350);
        },
        loadTabPreco(value = ".*") {
            this.serviceTabPreco
                .findAllComboTabPreco(50, value ? value : "")
                .then(this.mapItemsTabPreco)
                .then(allTabPreco => {
                    this.tabprecos = allTabPreco ? allTabPreco : [];
                    this.tabprecos.unshift(this.tabPrecoVazia());
                    this.isChanged = false;
                }, 350);
        },
        getLabel(option) {
            if (option.label) {
                return this.$t(option.label);
            } else {
                return null;
            }
        },
        save() {
            let pacoteTemp = this.mapOnSave(this.pacote);
                pacoteTemp.descricao = this.mapTosave(pacoteTemp.descricao);
            if (this.validation.validate(pacoteTemp, this.$refs)) {
                this.isSaving = true;
                this.service.save(pacoteTemp)
                    .then(body => {
                        if (body.content) {
                        let msg =
                            this.$t(this.pacote.idpacote != null
                                    ? "msg-edit-sucesso-n"
                                    : "msg-save-sucesso-n", 
                                { n: this.$t("pacote-kit") }
                            );
                            this.msgs.push(new Message("success", msg, true, false));
                            this.isChanged = false;
                            this.redirectToPage();
                        } else {
                            this.isChanged = false;
                            this.isSaving = false;

                            let message = body.message;
                            if (message && this.$te(message)) {
                                if (message == "msg-codigo-duplicado-n") {
                                    this.msgs.push(new Message(
                                        'alert', 
                                        this.$t(message, { n: pacoteTemp.idpacoteerp }), 
                                        true, 
                                        false
                                    ));
                                } else {
                                    this.msgs.push(new Message('alert', message, true));
                                }

                                return;
                            }

                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    });}},
        mapOnSave (pacote) {
            return {
                idpacote: pacote.idpacote,
                idpacoteerp: pacote.idpacoteerp,
                descricao: pacote.descricao,
                situacao: pacote.situacao.id,
                datavalidade: new Date(this.$moment(pacote.datavalidade)),
                imutavel: pacote.imutavel.id == 1 ? 'S' : 'N',
                qtdedisponivel: pacote.qtdedisponivel,
                idcategoria: pacote.categoria ? pacote.categoria.idcategoria : null,
                idtabpreco: pacote.tabpreco ? pacote.tabpreco.idtabpreco : null,
                idempresa: pacote.empresa ? pacote.empresa.idempresa : null,
            }
        },
        updateQtdeDisponivel(value){
            this.pacote.qtdedisponivel = value;
        },
        updateCategoria(categoria) {
            if (categoria) {
                this.pacote.categoria = categoria;
            } else {
                this.pacote.categoria = null;
            }
        },
        updateEmpresa(empresa) {
            if (empresa) {
                this.pacote.empresa = empresa;
            } else {
                this.pacote.empresa = null;
            }
        },
        updateTabPreco(tabpreco) {
            if (tabpreco) {
                this.pacote.tabpreco = tabpreco;
            } else {
                this.pacote.tabpreco = null;
            }
        },
        mapPacote(pacote){
            this.pacote.idpacoteerp = pacote.idpacoteerp;
            this.pacote.idpacote = pacote.idpacote;
            this.pacote.descricao = pacote.descricao;
            this.pacote.qtdedisponivel = pacote.qtdedisponivel;
            this.pacote.datavalidade = new Date(this.$moment(pacote.datavalidade));
            this.pacote.imutavel = pacote.imutavel == 'N' ? {id: 0,label: 'nao'} : {id:1, label: 'sim'};
            this.pacote.empresa = pacote.idempresa != 0 
                ? {idempresa: pacote.idempresa, label: pacote.idempresa+' - '+pacote.empresa.nome} 
                : this.empresaVazia();
            this.pacote.tabpreco = {
                idtabpreco: pacote.idtabpreco,
                label: pacote.idtabpreco+' - '+pacote.tabpreco.descricao
            };
            if(pacote.idcategoria) {
                this.pacote.categoria = {
                    idcategoria: pacote.idcategoria,
                    label: pacote.idcategoria+' - '+pacote.categoria.descricao
                };
            }
            this.pacote.situacao = {
                id: pacote.situacao,
                label: pacote.situacao == 1 ? 'ativo' : 'inativo'
            };

            this.isImutavel = this.pacote.imutavel.id == 1
        },
        mapItemsCategoria(body) {
            return body.content ? body.content.map(m => {
                return {                       
                    idcategoria: m.idcategoria,
                    descricao: m.descricao,
                    label: m.idcategoria +" - "+ m.descricao
                }
        }) : [];},
        mapItemsTabPreco(body) {
            return body.content ? body.content.map(m => {
                return {                    
                    idtabpreco: m.idtabpreco,
                    descricao: m.descricao,
                    label: m.idtabpreco+" - "+m.descricao
                }
        }) : [];},
        mapItemsEmpresa(body) {
            return body.content ? body.content.map(m => {
                return {
                    idempresa: m.idempresa,
                    descricao: m.nome,
                    label: m.idempresa+" - "+m.nome
                }
        }) : [];},
        empresaVazia(){
            return {
                idempresa: 0,
                descricao: this.$t("nenhuma-associacao-generica").toUpperCase(),
                label: this.$t("nenhuma-associacao-generica").toUpperCase(),
            }
        },
        tabPrecoVazia() {
            return {
                idtabpreco: 0,
                label: this.$t("nenhuma-associacao-generica").toUpperCase()
            };
        },

        redirectToPage() {
            let tempTela = null;
            let tempAba = null;
            if(this.$route.query.tela == 'produto-pacote-kit'){
                tempTela = 'ven-produto-politica-comercial-edit';
                tempAba = 'pacote-kit';
            }else{
                tempTela = "ven-pacote-kit-list";
            }
            const route = {
                    name: tempTela,
                    params: { id: this.$route.query['id'] },
                    query: { abaSelecionada: tempAba },
                    }
            setTimeout(() => {
                this.$router.push(route);
            }, 1000);
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
